// Module
var code = "<abx-work-order-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.closedWorkOrders\" abx-fetch=\"vm.fetchClosedWorkOrders(skip, limit)\" abx-fetch-all=\"vm.fetchAllClosedWorkOrders(limit)\" abx-status=\"vm.status\"> </abx-work-order-list> ";
// Exports
module.exports = code;